import { deleteGlobalPayment } from '@/api/tablet';
import { useMutation } from 'react-query';

const useDeleteGlobalPayment = (userId: string, tabletId: string) => {
  return useMutation({
    mutationFn: ({ paymentId }: { paymentId: string }) =>
      deleteGlobalPayment(userId, tabletId, paymentId),
  });
};

export default useDeleteGlobalPayment;
